/* import __COLOCATED_TEMPLATE__ from './qualification.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/use-brace-expansion */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { notEmpty, readOnly } from '@ember/object/computed';
import Component from '@ember/component';

export default Component.extend({
  qualificationAttributes: readOnly('app.qualification_attributes'),
  showQualificationAttributeList: notEmpty('qualificationAttributes'),
});
